import React, { useEffect, useState } from 'react';
import {
  Box,
  CircularProgress,
  Grid,
} from '@mui/material';
import BenefitDetailCard from './BenefitDetailCard';
import PolicySection from './PolicySection';
import ClubProgressSlider from './ClubProgressSlider';
import ReusableComparisonTable from './ReusableComparisonTable';
import { BenefitDetailAction } from '../APIs/action';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import {
  Search as SearchIcon,
} from '@mui/icons-material';
import { CustomButton } from '../../../MUI_custom_component';


const LIMIDetailPage = () => {
	const location = useLocation();
	const navigate = useNavigate();

	const insuranceType = location.state?.insuranceType;
	const selectedManufacturer = location.state?.selectedManufacturer;
	const selectedCompanyEntity = location.state?.selectedCompanyEntity;

	const [benefitDetail, setBenefitDetail] = useState([]);
	const [loader, setLoader] = useState(false);

	const benefitDetails = benefitDetail?.benefit_card;
	const policyDetails = benefitDetail?.policy_details || [];
	const clubProgressDetails = benefitDetail?.club_progress_details;
	const previousPolicy = benefitDetail?.previous_policies;
	const getBenefitDetail = async (selectedManufacturer, insuranceType, selectedCompanyEntity) => {
		setLoader(true);
		const { data, message, error } = await BenefitDetailAction( selectedManufacturer, insuranceType, selectedCompanyEntity );
		setLoader(false);
		if (!error) {
			setBenefitDetail(data);
		} else {
			toast.error(message);
		}
	};
	useEffect(()=>{
		if(selectedManufacturer && insuranceType && selectedCompanyEntity){
			getBenefitDetail(selectedManufacturer, insuranceType, selectedCompanyEntity);
		}else{
			navigate('/benefits/mybenefits', { replace: true });
		}
	},[ selectedManufacturer, insuranceType, selectedCompanyEntity ])
	
	const handleSearchHospitalclick = () => {
        navigate('/benefits/network-hospital');
    };

	if (loader) {
		return (
			<Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
				<CircularProgress/>
			</Box>
		);
	}
	return (
		<Box sx={{ p: { xs:2, md:3 } }}>
			<Grid container spacing={{xs:2, md:4}} sx={{ mb: 2 }}>
				<Grid item xs={12} md={6} sx={{ display: 'flex', flexDirection: 'column' }}>
					<Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', p: 2, background: '#ffffff', border: '1px solid #D9D9D9', borderRadius: 2 }}>
						<BenefitDetailCard benefitDetails={benefitDetails} spacing={false}/>
					</Box>
				</Grid>
				{clubProgressDetails && (
					<Grid item xs={12} md={6} sx={{ display: 'flex', flexDirection: 'column' }}>
						<Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', background: '#ffffff' }}>
							<ClubProgressSlider progress={clubProgressDetails} insurance={false} />
						</Box>
					</Grid>
				)}
				{policyDetails && (
					<Grid item xs={12} md={6}>
						<PolicySection policy_details={policyDetails} insuranceType={insuranceType}  selectedCompanyEntity={selectedCompanyEntity} />
						{benefitDetail?.show_network_hospitals && (
							<CustomButton
							variant="outlined"
							color="primary"
							label="Search Network Hospitals"
							fullWidth
							sx={{ mt: 2 }}
							leftIcon={SearchIcon }
							onClick={handleSearchHospitalclick}
						/>
						)}
					</Grid>
				)}
				{previousPolicy && previousPolicy?.table_list_dtos?.length>0 && (
					<Grid item xs={12} md={6}>
						<ReusableComparisonTable
							title="Previous Policies"
							tableInfo={previousPolicy}
							headerVariant = 'labelD'
							footerVariant = 'body1'
							cellVariant = 'body1'
						/>
					</Grid>
				)}
				
			</Grid>
		</Box>
	);
};

export default LIMIDetailPage;
